import WidgetsIcon from "@mui/icons-material/Widgets";
import GroupIcon from "@mui/icons-material/Group";
import SettingsIcon from "@mui/icons-material/Settings";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import CalculateIcon from "@mui/icons-material/Calculate";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PsychologyIcon from "@mui/icons-material/Psychology";
import ExploreIcon from "@mui/icons-material/Explore";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import GrassIcon from "@mui/icons-material/Grass";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import SchoolIcon from "@mui/icons-material/School";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import InsightsIcon from "@mui/icons-material/Insights";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import HistoryIcon from "@mui/icons-material/History";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { SpecialPermissions } from "../../../types/user";
import { SvgIconProps } from "@mui/material";

export interface NavLinkItem {
  menu_title: string;
  menu_icon: (props?: SvgIconProps) => JSX.Element;
  newItem: boolean;
  path: string;
  mobileEnabled?: boolean;
  requiredPermissions?: SpecialPermissions[];
  onlyCompanyAdmin?: boolean;
  onlySuperAdmin?: boolean;
  onlyVendors?: boolean;
  superAdminTitle?: string;
  companyAdminTitle?: string;
  firstSuperAdminItem?: boolean;
}

const NavLinks: NavLinkItem[] = [
  {
    menu_title: "Dashboard",
    menu_icon: (props = {}) => <WidgetsIcon {...props} />,
    newItem: false,
    path: "/dashboard",
    mobileEnabled: true,
  },
  {
    menu_title: "Farm Management",
    menu_icon: (props = {}) => <AccountTreeIcon {...props} />,
    newItem: false,
    path: "/farm-management",
    requiredPermissions: [SpecialPermissions.FarmManagement],
    mobileEnabled: true,
  },
  {
    menu_title: "Intake Management",
    menu_icon: (props = {}) => <InsightsIcon {...props} />,
    newItem: false,
    path: "/intake-management",
    requiredPermissions: [SpecialPermissions.IntakeManagement],
  },
  {
    menu_title: "Manage Users",
    menu_icon: (props = {}) => <GroupIcon {...props} />,
    newItem: false,
    path: "/users",
    onlyCompanyAdmin: true,
    mobileEnabled: true,
  },
  {
    menu_title: "Manage Labs",
    superAdminTitle: "Manage Labs & Clients",
    companyAdminTitle: "Manage Clients",
    menu_icon: (props = {}) => <LocationCityIcon {...props} />,
    newItem: false,
    path: "/companies",
    onlyCompanyAdmin: true,
    onlyVendors: true,
    mobileEnabled: true,
  },
  {
    menu_title: "Documentation",
    menu_icon: (props = {}) => <MenuBookIcon {...props} />,
    newItem: false,
    path: "/documentation",
    requiredPermissions: [SpecialPermissions.Documentation],
    mobileEnabled: true,
  },
  {
    menu_title: "Prediction Model",
    menu_icon: (props = {}) => <PsychologyIcon {...props} />,
    newItem: false,
    path: "/prediction-model",
    requiredPermissions: [SpecialPermissions.PredictionModel],
  },
  {
    menu_title: "Manage Trainings",
    menu_icon: (props = {}) => <SchoolIcon {...props} />,
    newItem: false,
    path: "/trainings",
    requiredPermissions: [SpecialPermissions.Training],
  },
  {
    menu_title: "Training Reports",
    menu_icon: (props = {}) => <AssessmentIcon {...props} />,
    newItem: false,
    path: "/training-report",
    requiredPermissions: [SpecialPermissions.Training],
  },
  {
    menu_title: "Dairy Ration",
    menu_icon: (props = {}) => <WorkspacesIcon {...props} />,
    newItem: true,
    path: "/dairy-ration",
    requiredPermissions: [SpecialPermissions.DietRation],
    mobileEnabled: true,
  },
  {
    menu_title: "Onboarding Guides",
    menu_icon: (props = {}) => <ExploreIcon {...props} />,
    newItem: false,
    path: "/onboarding-guides",
    mobileEnabled: true,
  },  
  // {
  //   menu_title: "ISC NIR Scanner",
  //   menu_icon: (props = {}) => <BiotechIcon {...props} />,
  //   newItem: false,
  //   path: "/isc-nir-scanner",
  //   onlySuperAdmin: true,
  // },
  {
    menu_title: "Settings",
    menu_icon: (props = {}) => <SettingsIcon {...props} />,
    newItem: false,
    path: "/settings",
    onlySuperAdmin: true,
    firstSuperAdminItem: true,
  },
  {
    menu_title: "Knowledge Pool",
    menu_icon: (props = {}) => <AutoStoriesIcon {...props} />,
    newItem: true,
    path: "/knowledge-pool",
    onlySuperAdmin: true,
  },
  {
    menu_title: "Ask Logs",
    menu_icon: (props = {}) => <HistoryIcon {...props} />,
    newItem: true,
    path: "/ask-logs",
    onlySuperAdmin: true,
  },
  {
    menu_title: "API Logs",
    menu_icon: (props = {}) => <ManageSearchIcon {...props} />,
    newItem: false,
    path: "/api-logs",
    onlySuperAdmin: true,
  },
  // {
  //   menu_title: "Sample Sources (farm)",
  //   menu_icon: (props = {}) => <GiteIcon {...props} />,
  //   newItem: false,
  //   path: "/sample-sources",
  //   onlySuperAdmin: true,
  // },
  // {
  //   menu_title: "Gas Analysis",
  //   menu_icon: (props = {}) => <StorageIcon {...props} />,
  //   newItem: false,
  //   path: "/gas-analysis",
  //   onlySuperAdmin: true,
  // },
  {
    menu_title: "Crop Types",
    menu_icon: (props = {}) => <GrassIcon {...props} />,
    newItem: false,
    path: "/crop-types",
    onlySuperAdmin: true,
  },
  {
    menu_title: "R&D Schedule",
    menu_icon: (props = {}) => <PendingActionsIcon {...props} />,
    newItem: false,
    path: "/rd-schedule",
    onlySuperAdmin: true,
    requiredPermissions: [SpecialPermissions.RdSchedule],
  },
  {
    menu_title: "Additive Algorithms",
    menu_icon: (props = {}) => <CalculateIcon {...props} />,
    newItem: false,
    path: "/additive-algorithms",
    onlySuperAdmin: true,
  },
  // {
  //   menu_title: "Feeders",
  //   menu_icon: (props = {}) => <VaccinesIcon {...props} />,
  //   newItem: false,
  //   path: "/feeders",
  //   onlySuperAdmin: true,
  // },
];

export default NavLinks;
